import React from 'react';
import './Pagination.css';

const Pagination = ({ 
  currentPage, 
  totalItems, 
  itemsPerPage, 
  onPageChange 
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  // If there's only one page, don't show pagination
  if (totalPages <= 1) return null;

  return (
    <div className="pagination">
      <div className="pagination-info">
        Page {currentPage} of {totalPages}
        <span className="pagination-item-count">
          ({(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems})
        </span>
      </div>
      
      <div className="pagination-buttons">
        <button 
          onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
          disabled={currentPage === 1}
          className="pagination-button"
        >
          <i className="fas fa-chevron-left"></i> Previous
        </button>
        
        <button 
          onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
          disabled={currentPage >= totalPages}
          className="pagination-button"
        >
          Next <i className="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>
  );
};

export default Pagination;